<template>
	<div class="dropdown-list-separator"></div>
</template>

<script>
export default {
  props: [
    'icon'
  ]
}
</script>
